var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyzeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-355 -1984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(355 1984)",
    fill: "#fedde5"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Icon_",
    "data-name": "Icon ",
    width: 38,
    height: 38,
    transform: "translate(366 1995)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAABHNCSVQICAgIfAhkiAAAA0tJREFUWEfNmEuIT1Ecx/3zyJukichrIcr7NRYiqVEsxcZjwQKJLEQsWChGKSmxQBJJIVlYyWQh8n6FlMd4J8MYolkI38+/e6bzv+7r3Hv+zKlv95x7z+93Pvd3zz2vUlPtwg450hTZzJCmSuOkUnD9petFaZB0X7ohXZUuu7ZRcgDrIucrpSXStFBDrSp3C+490XVk6PkDlU9K+6UvWSCzgq2Vs43S4Binb61n1yLAjVmzMrulHWlwaWDD5eCINCvFUVYw4+aeMsul23F+k8Dmyuis9YmS2FzBjK+lyhyPchwHtkCVT6eF23qeFwwXa4K+V9FcFNhs1WhwgKJqETDsF0mn7DbDYDVBI53+MRjNjZEemnbDYNf1gLHJNRWNGO29loZEgfGXHHYlCur7AMPVdmkrGTtijDF9/zMYzfeRvhqwFSocygmFma+ItUXNgDFl0PnyJp9gHwVRA9hoZR7lJfLcxwzGHMDWqbS3nYHVA3ZUUMvaGVgDYLcENckj2Av5GlbQXytg7+RkYEFHduc/I18TJRaNeRKLzhbAvinTM48Hy+aV8kML+qgw9wX2Q15ZtRI5k3jz33lhAXsv4wF5HVh29C0+YYvUXToo1Un4dwHkhcojP6tIHPpIz+RkutQkjZJYZvfO4fgnYMdkyAbDV6K/8aKfJTYorFhcZ5VLgK2X4R5fVIGf57rWBpHrqusVx6+yCzDehrnSd7Ijx9bvpjQ2YyN1ZhJ/HPSJjHaZq9Hn2ByzlyRybIDTPusn1SlP4rSyWmIzWo3UKKesivkhgKPPJUWuXs83G7DyLyoVHWjjXuylHkzIGLl+qtdsr2BX6caBaoQs8BmOHGcawNpppwpbuBHejNzVvfFVhLMj11ntMIaaPvdB+baBPgzGKc2bKoLhmh+CQxkzzlFmEcEK545pO2rDO08Pz1cZjshNlvgDOR8hX7HzjzsiWKyKkWcKHoGBmi8xbf2Vkg5VMDondfQIE3ZFAE64glGfjQrHUEwvPhOHe2ywmaoiU9r5mDHapMwGqX9Buu+yZ17eJiWucLOCwdNL4siI8KdNK2H+p7rBUec+iWEhNbmA2c5mqsDhML/9iCCSPXRlBiEqdOxGiemHgfRCKkmowh/eGNyPN6tQtAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeIcon);
export default __webpack_public_path__ + "static/media/Analyze_Icon.4e27d549228010029a04edf08d4f6a2c.svg";
export { ForwardRef as ReactComponent };